import React from 'react';
import { Form, Label } from 'semantic-ui-react';

const renderRadio = ({
  input,
  label,
  customClass,
  type,
  errorMessage,
  meta: { touched, error },
}) => {
  const showError = errorMessage && touched && error;
  return (
    <Form.Field className={ `${customClass} ${touched && error ? 'error' : ''} ` }>
      <div className="ui radio checkbox">
        <input id={ `${input.name}-${input.value}` } { ...input } type={ type } />
        <label htmlFor={ `${input.name}-${input.value}` }>{ label }</label>
      </div>

      {showError && <Label basic pointing>{ errorMessage }</Label> }
    </Form.Field>
  );
};

export default renderRadio;
